import { DecorationItem } from "./DecorationItem";

export default DecorationItem;
